import zhCN from './langs/zh-cn';
import enUS from './langs/en-us';
const locales: Record<App.I18n.LangType, App.I18n.Schema> = {
  'zh_CN': zhCN,
  'en_US': enUS
};

export default locales;
